import { AlarmLevel, DeviationAlarmRecord, MonitorType } from './types';

const monitorObjects = [
  { type: MonitorType.LOAD, name: '空压机01' },
  { type: MonitorType.LOAD, name: '电石炉#1' },
  { type: MonitorType.PV, name: '东南一号光伏站' },
  { type: MonitorType.STORAGE, name: '一号储能站' },
  { type: MonitorType.THERMAL, name: '一号火电机组' },
];

const alarmLevels = [
  AlarmLevel.LOW,
  AlarmLevel.LOW,
  AlarmLevel.LOWEST,
  AlarmLevel.LOWEST,
  AlarmLevel.MEDIUM,
  AlarmLevel.HIGHEST,
  AlarmLevel.HIGH,
  AlarmLevel.HIGH,
];

export const MOCK_ALARMS: DeviationAlarmRecord[] = Array.from({ length: 36 }, (_, index) => {
  const monitorObject = monitorObjects[index % monitorObjects.length];

  return {
    id: index + 1,
    monitorType: monitorObject.type,
    monitorObject: monitorObject.name,
    alarmRule: index % 2 === 0 ? '电流过大' : '功率偏差',
    alarmRuleCode: `RO${10383111329 + index}`,
    alarmLevel: alarmLevels[index % alarmLevels.length],
    threshold: 26,
    deviationRate: 26.97 + (index % 8) * 0.36,
    alarmTime: `2025-01-${String(31 - (index % 20)).padStart(2, '0')} 16:${String(7 + (index % 40)).padStart(
      2,
      '0'
    )}:25`,
    recoveryTime: `2025-01-${String(31 - (index % 20)).padStart(2, '0')} 16:${String(17 + (index % 40)).padStart(
      2,
      '0'
    )}:25`,
    dispatchSuggestion: 2274.5 + index * 10,
    actualExecution: 2000 + index * 8,
  };
});

export const getMockAlarm = (id: number) => MOCK_ALARMS.find(item => item.id === id);
